/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegionResponse
 */
export interface RegionResponse {
    /**
     * 
     * @type {number}
     * @memberof RegionResponse
     */
    regionId: number;
    /**
     * 
     * @type {string}
     * @memberof RegionResponse
     */
    carrierRegion: string;
    /**
     * 
     * @type {string}
     * @memberof RegionResponse
     */
    mccMnc: string;
    /**
     * 
     * @type {string}
     * @memberof RegionResponse
     */
    locale: string;
    /**
     * 
     * @type {string}
     * @memberof RegionResponse
     */
    timezoneName: string;
    /**
     * 
     * @type {string}
     * @memberof RegionResponse
     */
    carrierName: string;
    /**
     * 
     * @type {string}
     * @memberof RegionResponse
     */
    timezoneLongName: string;
}

/**
 * Check if a given object implements the RegionResponse interface.
 */
export function instanceOfRegionResponse(value: object): value is RegionResponse {
    if (!('regionId' in value) || value['regionId'] === undefined) return false;
    if (!('carrierRegion' in value) || value['carrierRegion'] === undefined) return false;
    if (!('mccMnc' in value) || value['mccMnc'] === undefined) return false;
    if (!('locale' in value) || value['locale'] === undefined) return false;
    if (!('timezoneName' in value) || value['timezoneName'] === undefined) return false;
    if (!('carrierName' in value) || value['carrierName'] === undefined) return false;
    if (!('timezoneLongName' in value) || value['timezoneLongName'] === undefined) return false;
    return true;
}

export function RegionResponseFromJSON(json: any): RegionResponse {
    return RegionResponseFromJSONTyped(json, false);
}

export function RegionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'regionId': json['region_id'],
        'carrierRegion': json['carrier_region'],
        'mccMnc': json['mcc_mnc'],
        'locale': json['locale'],
        'timezoneName': json['timezone_name'],
        'carrierName': json['carrier_name'],
        'timezoneLongName': json['timezone_long_name'],
    };
}

export function RegionResponseToJSON(json: any): RegionResponse {
    return RegionResponseToJSONTyped(json, false);
}

export function RegionResponseToJSONTyped(value?: RegionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'region_id': value['regionId'],
        'carrier_region': value['carrierRegion'],
        'mcc_mnc': value['mccMnc'],
        'locale': value['locale'],
        'timezone_name': value['timezoneName'],
        'carrier_name': value['carrierName'],
        'timezone_long_name': value['timezoneLongName'],
    };
}

